import { render, staticRenderFns } from "./company-description.vue?vue&type=template&id=607680b8&scoped=true"
import script from "./company-description.vue?vue&type=script&lang=js"
export * from "./company-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607680b8",
  null
  
)

export default component.exports